var _path, _path2, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWinnerFaceIcon = function SvgWinnerFaceIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7598 22.4329C45.7598 33.5047 36.4401 42.5419 24.8662 42.5419C13.2923 42.5419 3.97266 33.5047 3.97266 22.4329C3.97266 11.361 13.2923 2.32385 24.8662 2.32385C36.4401 2.32385 45.7598 11.361 45.7598 22.4329Z",
    fill: "#272054",
    stroke: "#272054",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_805_386",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7848 -3.62712e-07L30.2726 15.7247L48.391 22.556L48.3911 44L0.391107 44L0.391109 7.01394e-05L39.7848 -3.62712e-07Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_805_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0457 41.8497C13.9673 41.8497 5.04941 33.1999 5.04941 22.6058C5.04942 12.0118 13.9673 3.36194 25.0457 3.36194C36.1241 3.36194 45.042 12.0118 45.042 22.6058C45.042 33.1999 36.1241 41.8497 25.0457 41.8497Z",
    stroke: "url(#paint0_linear_805_386)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_805_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0457 41.8497C13.9673 41.8497 5.04941 33.1999 5.04941 22.6058C5.04942 12.0118 13.9673 3.36194 25.0457 3.36194C36.1241 3.36194 45.042 12.0118 45.042 22.6058C45.042 33.1999 36.1241 41.8497 25.0457 41.8497Z",
    stroke: "url(#paint1_linear_805_386)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.0457 41.8497C13.9673 41.8497 5.04941 33.1999 5.04941 22.6058C5.04942 12.0118 13.9673 3.36194 25.0457 3.36194C36.1241 3.36194 45.042 12.0118 45.042 22.6058C45.042 33.1999 36.1241 41.8497 25.0457 41.8497Z",
    stroke: "url(#paint2_linear_805_386)",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0514 36.0004C46.6767 28.6483 46.6767 16.7283 39.0514 9.37621C31.4261 2.02415 19.063 2.02415 11.4377 9.37621C3.8124 16.7283 3.81239 28.6483 11.4377 36.0004C19.063 43.3524 31.4261 43.3524 39.0514 36.0004Z",
    fill: "url(#paint3_linear_805_386)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_805_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.811 34.3763C31.751 34.3763 37.377 28.9519 37.377 22.2606C37.377 15.5694 31.751 10.145 24.811 10.145C17.8711 10.145 12.2451 15.5694 12.2451 22.2606C12.2451 28.9519 17.8711 34.3763 24.811 34.3763Z",
    fill: "url(#paint4_linear_805_386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6375 30.818C20.4892 30.3268 21.5775 28.4813 21.0681 26.6959C20.5587 24.9105 18.6446 23.8613 16.7929 24.3524C14.9411 24.8435 13.8529 26.689 14.3622 28.4744C14.8716 30.2598 16.7857 31.3091 18.6375 30.818Z",
    fill: "#E5E5FC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.241 30.9314C34.148 30.7118 35.5093 29.0432 35.2816 27.2046C35.0538 25.3659 33.3233 24.0534 31.4163 24.273C29.5093 24.4925 28.148 26.1611 28.3757 27.9997C28.6035 29.8384 30.334 31.1509 32.241 30.9314Z",
    fill: "#E5E5FC",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0333 26.4314C22.0514 25.4932 22.8987 23.1553 21.9257 21.2094C20.9527 19.2636 18.5278 18.4467 16.5097 19.3848C14.4915 20.323 13.6443 22.6609 14.6173 24.6068C15.5903 26.5526 18.0151 27.3695 20.0333 26.4314Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4775 26.3591C34.6294 25.7575 35.868 23.5879 35.244 21.5131C34.6201 19.4384 32.3699 18.2442 30.218 18.8458C28.0662 19.4474 26.8276 21.617 27.4515 23.6917C28.0755 25.7664 30.3257 26.9606 32.4775 26.3591Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8579 18.4592C16.1799 18.127 16.5852 17.8804 17.0347 17.7432C17.4843 17.6059 17.963 17.5826 18.4246 17.6756",
    stroke: "#383452",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.322 18.4593C33 18.1272 32.5946 17.8807 32.1451 17.7434C31.6956 17.6062 31.217 17.5828 30.7554 17.6756",
    stroke: "#383452",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3867 24.536C23.522 24.7957 23.7295 25.014 23.986 25.1666C24.2425 25.3191 24.538 25.3999 24.8394 25.3999C25.1408 25.3999 25.4362 25.3191 25.6928 25.1666C25.9493 25.014 26.1568 24.7957 26.292 24.536",
    stroke: "#383452",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6115 20.3427C20.6229 20.411 20.6288 20.4799 20.6293 20.549C20.6298 20.8047 20.5531 21.0551 20.4086 21.2696C20.264 21.4841 20.0579 21.6534 19.8153 21.7569C19.5727 21.8603 19.3041 21.8935 19.0422 21.8524C18.7804 21.8112 18.5367 21.6975 18.3407 21.5251L18.2944 21.5595L18.3211 21.5079C18.1782 21.3778 18.066 21.2196 17.9922 21.044C17.9183 20.8684 17.8846 20.6796 17.8932 20.4903C17.9018 20.301 17.9527 20.1157 18.0422 19.947C18.1317 19.7783 18.2578 19.6302 18.412 19.5127C18.3336 19.5127 18.2552 19.5127 18.1749 19.5127C17.331 19.5339 16.5214 19.8395 15.8867 20.3762C15.2521 20.913 14.8324 21.6471 14.7006 22.4511C14.5688 23.2551 14.7331 24.0782 15.1651 24.7775C15.5972 25.4769 16.2695 26.0083 17.0656 26.2794C17.8616 26.5506 18.7309 26.5445 19.5227 26.262C20.3145 25.9796 20.9787 25.4388 21.4001 24.7334C21.8214 24.028 21.9732 23.2026 21.8291 22.4006C21.6851 21.5985 21.2543 20.8705 20.6115 20.3427Z",
    fill: "#383452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6412 19.9784C33.7628 20.2226 33.8035 20.4969 33.7579 20.7641C33.7123 21.0313 33.5825 21.2785 33.3862 21.4722C33.1898 21.6659 32.9365 21.7966 32.6604 21.8467C32.3844 21.8968 32.0991 21.8638 31.8431 21.7523C31.5872 21.6407 31.3731 21.4559 31.2298 21.2229C31.0865 20.99 31.021 20.7202 31.0422 20.4502C31.0634 20.1801 31.1702 19.9229 31.3482 19.7134C31.5261 19.5039 31.7666 19.3522 32.0371 19.279C31.1889 19.136 30.3157 19.2963 29.5814 19.7298C28.8471 20.1632 28.302 20.8402 28.0484 21.6335C27.7949 22.4269 27.8502 23.2822 28.2041 24.0391C28.5581 24.7959 29.1862 25.4022 29.9708 25.7443C30.7553 26.0863 31.6424 26.1407 32.4655 25.8971C33.2887 25.6535 33.9913 25.1287 34.4418 24.4211C34.8922 23.7136 35.0594 22.8719 34.912 22.054C34.7646 21.236 34.3128 20.4981 33.6412 19.9784Z",
    fill: "#383452"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_805_386",
    x: 0.0493164,
    y: -1.63806,
    width: 49.9927,
    height: 48.4878,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_805_386"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_805_386",
    x1: 40.2599,
    y1: 22.6056,
    x2: 16.9401,
    y2: -9.0613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC74FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_805_386",
    x1: 40.2599,
    y1: 22.6056,
    x2: 16.9401,
    y2: -9.0613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC74FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_805_386",
    x1: -38.5993,
    y1: 26.4016,
    x2: 36.8793,
    y2: 4.51814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272054",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563001,
    stopColor: "#27CBFF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272054",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_805_386",
    x1: 7.4543,
    y1: 12.7242,
    x2: 37.1941,
    y2: 41.2594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_805_386",
    x1: 22.8476,
    y1: -47.8944,
    x2: 65.9693,
    y2: 9.68994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA57FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.0547,
    height: 37.6552,
    fill: "white",
    transform: "translate(5.71875 3.86145)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_805_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.1301,
    height: 24.2295,
    fill: "white",
    transform: "translate(12.2451 10.145)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWinnerFaceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/winner-face-icon.2cbaeccc.svg";
export { ForwardRef as ReactComponent };